import { Component, inject, output, signal, ChangeDetectionStrategy } from '@angular/core';
import { FormField, form, required } from '@angular/forms/signals';
import { ICategoriaData } from '@core/interfaces/entidades/categoria.entidad';
import { ICrearCategoriaReq } from '@core/interfaces/request-response/categoria.dto.interface';
import { CategoriaApiService } from '@core/services/api/categoria-api.service';
import { LoadingService } from '@shared/services/loading.service';
import { ToastService } from '@shared/services/toast.service';

@Component({
  selector: 'app-crear-categoria',
  imports: [FormField],
  templateUrl: './crear-categoria.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './crear-categoria.css',
})
export class CrearCategoria {
  // servicios
  private toastService = inject(ToastService);
  private categoriaApiService = inject(CategoriaApiService);
  private loadingService = inject(LoadingService);
  // datos
  isLoading = this.loadingService.loadingSubject;
  cerrar = output<ICategoriaData | undefined>();
  categoriaForm = form(
    signal({
      nombre: '',
      descripcion: '',
    }),
    (schemaPath) => {
      required(schemaPath.nombre, { message: 'El nombre de la categoría es obligatorio.' });
    },
  );
  private checkInvalidForm(): boolean {
    if (this.categoriaForm().invalid()) {
      this.markAllAsTouched();
      this.toastService.show(
        'top-right',
        'error',
        'Error',
        'Por favor, complete los campos obligatorios.',
      );
      return true;
    }
    return false;
  }
  private markAllAsTouched() {
    this.categoriaForm.nombre().markAsTouched();
  }
  // metodos
  onCerrar(data?: ICategoriaData) {
    this.cerrar.emit(data);
  }
  guardar(event: Event) {
    event.preventDefault();

    if (this.checkInvalidForm()) return;
    const { nombre, descripcion } = this.categoriaForm().controlValue();
    const rq: ICrearCategoriaReq = {
      nombre,
      descripcion,
    };
    this.categoriaApiService.crear(rq).subscribe({
      next: (data) => {
        this.toastService.show(
          'top-right',
          'success',
          'Éxito',
          'Categoría actualizada correctamente.',
        );
        this.onCerrar(data);
      },
      error: (err) => {
        if (err.status == 401) return;
        this.toastService.show(
          'top-right',
          'error',
          'Error',
          err.error.message || 'Error al actualizar la categoría.',
        );
      },
    });
  }
}
